import React from 'react'
import { Tag } from 'antd'
import { themeConfig } from 'config'
import { ShopOutlined } from '@ant-design/icons'

type Props = {
  text: string
  isFranchise?: boolean
}

const FranchiseTag = (props: Props) => {
  const { text, isFranchise } = props
  return (
    <div>
      <div>{text}</div>
      {isFranchise && (
        <div>
          <Tag color={themeConfig.colors.primary} icon={<ShopOutlined />}>
            ร้านค้าแฟรนไชส์
          </Tag>
        </div>
      )}
    </div>
  )
}

export default FranchiseTag
